import React from 'react';
import PropTypes from 'prop-types';
import useDebounce from 'hooks/useDebounce';
import styles from './style.cssmodule.css';

const withSkeleton = (Element) => {
  const SkeletonComponent = ({
    loading,
    forceDisplay,

    height,
    width,
    debounceValue,
  }) => {
    const debouncedLoading = useDebounce(loading, debounceValue);

    if (debouncedLoading || forceDisplay) {
      return <div className={styles.skeleton} style={{ width, height, animationName: styles.shine }} />;
    }

    return Element;
  };
  SkeletonComponent.propTypes = {
    loading: PropTypes.bool,
    forceDisplay: PropTypes.bool,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    debounceValue: PropTypes.number,
  };
  SkeletonComponent.defaultProps = {
    loading: false,
    forceDisplay: false,
    width: '100%',
    height: '100%',
    debounceValue: 0,
  };

  SkeletonComponent.displayName = 'withSkeleton';

  return SkeletonComponent;
};

withSkeleton.propTypes = {
  loading: PropTypes.bool,
  forceDisplay: PropTypes.bool,
  height: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOf([PropTypes.number, PropTypes.string]),
};

withSkeleton.defaultProps = {
  loading: false,
  forceDisplay: false,
  height: '100%',
  false: '100%',
};

export default withSkeleton;



// WEBPACK FOOTER //
// ./components/skeleton/WithSkeleton.jsx